import { useState, useContext, useEffect } from "react";

import { Container, Grid, IconButton, Tooltip } from "@material-ui/core";
import { ArchiveOutlined, DeleteOutline } from "@material-ui/icons";

import HeaderModule from "../../../components/header/HeaderModule.js";
import Loading from "../../../components/basics/Loading.js";
import TableDefault from "../../../components/grid/TableDefault.js";
import ModalDetailTriagem from "./children/ModalDetailTriagem";
import { GridStyled } from "../../../theme/styles/Layout";
import {
  TriagemContratoContext,
  TriagemContratoContextProvider,
} from "./contexts/TriagemContratoContext";
import { findClienteProposta } from "../../../repositories/qerpapi/erp/faturamento/ClientePropostaRepository.js";
import MaskService from "../../../utils/mask/maskService.jsx";
import TextFieldErp from "../../../components/basics/TextFieldErp.js";
import filterTable from "../../../utils/filterTable.js";
import { QueryParamsContext } from "../../../context/QueryParamsContext.js";
import useTriagemContratoController from "./controllers/TriagemContratoController.js";

let typingTimer = null;

const View = () => {
  const [loadingTable, setLoadingTable] = useState(false);
  const [textFilter, setTextFilter] = useState("");
  const [dataPreview, setDataPreview] = useState([]);
  const [page, setPage] = useState(0);

  const {
    customerProposals,
    setCustomerProposals,

    rowEdit,
    setRowEdit,
    loading,
  } = useContext(TriagemContratoContext);
  const { handleDeleteProposal } = useTriagemContratoController();
  const { queryParams } = useContext(QueryParamsContext);

  useEffect(() => {
    setDataPreview(customerProposals);
    setTextFilter("");
    setPage(0);
  }, [customerProposals]);

  const columns = [
    {
      label: "Ações",
      format: (value) => (
        <>
          <Tooltip title="Visualizar Proposta">
            <IconButton onClick={() => setRowEdit(value)}>
              <ArchiveOutlined />
            </IconButton>
          </Tooltip>

          <Tooltip title="Remover Proposta">
            <IconButton onClick={() => handleDeleteProposal(value)}>
              <DeleteOutline />
            </IconButton>
          </Tooltip>
        </>
      ),
      align: "center",
      style: { width: 110 },
    },
    {
      label: "Código",
      id: "proposta_crm_id",
      style: { width: 90 },
    },
    {
      label: "CPF/CNPJ",
      id: "cnpj",
      style: { width: 180 },
      format: (value) =>
        MaskService.toMask(
          value?.cliente?.cpfcnpj.replace(/[^0-9]+/g, "").length > 11
            ? "cnpj"
            : "cpf",
          value?.cliente?.cpfcnpj || ""
        ),
    },
    {
      label: "Razão",
      id: "razao",
      format: (value) => value?.cliente?.razao,
    },
    {
      label: "E-mail",
      id: "email",
      format: (value) => value?.cliente?.email,
    },
    {
      label: "Data de Revisão",
      id: "revisao_data",
      style: { width: 125 },
      format: (value) =>
        typeof value.revisao_data === "string"
          ? value.revisao_data.split("-").reverse().join("/")
          : "",
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLoadingTable(true);

        const response = await findClienteProposta({
          empresa_cnpj: queryParams.empresa_cnpj,
          include: "cliente",
          where: { aprovado: 0 },
        });

        if (response.success && Array.isArray(response.data)) {
          setCustomerProposals(response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingTable(false);
      }
    })();
  }, [setCustomerProposals, queryParams.empresa_cnpj]);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setDataPreview(
        filterTable({
          data: customerProposals,
          text: textFilter,
          columns: [
            "proposta_crm_id",
            "cliente.cpfcnpj",
            "cliente.apelido",
            "cliente.razao",
            "cliente.email",
            "revisao_data",
          ],
        })
      );
      setPage(0);
    }, 1000);
  }, [textFilter, customerProposals]);

  return (
    <>
      <Loading open={loading} />
      <HeaderModule title="TRIAGEM DE CONTRATOS" />

      {!!rowEdit?.id && <ModalDetailTriagem idProposal={rowEdit?.id} />}

      <Container maxWidth="xl">
        <GridStyled $margin="80px 0px 0px 0px" container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextFieldErp
              value={textFilter}
              setValue={setTextFilter}
              label="Busque por Código, CPF/CNPJ, Razão, Apelido ou E-mail"
              variant="filled"
            />
          </Grid>
          <Grid item xs={12}>
            <TableDefault
              selectable={false}
              columns={columns}
              tableTitle=""
              values={dataPreview}
              loading={loadingTable}
              pageProp={page}
              setPageProp={setPage}
            />
          </Grid>
        </GridStyled>
      </Container>
    </>
  );
};

const TriagemContrato = (props) => (
  <TriagemContratoContextProvider>
    <View {...props} />
  </TriagemContratoContextProvider>
);

export { TriagemContrato };
